'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border: 1px solid ', ';\n'], ['\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border: 1px solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    cursor: pointer;\n    caret-color: transparent;\n'], ['\n    cursor: pointer;\n    caret-color: transparent;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    border: 0;\n'], ['\n    position: relative;\n    border: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    margin-left: .5rem;\n    width: 1rem;\n    height: 1rem;\n    padding: .25rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 1;\n'], ['\n    margin-left: .5rem;\n    width: 1rem;\n    height: 1rem;\n    padding: .25rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 1;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    height: 60px;\n    border: 0;\n    background: none;\n\n    a {\n        ', ';\n    }\n'], ['\n    height: 60px;\n    border: 0;\n    background: none;\n\n    a {\n        ', ';\n    }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    position: relative;\n    height: 40px;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    outline: none;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    background: ', ';\n    background: ', ';\n    color: ', ';\n\n    ', ';\n    ', ';\n\n    &:disabled {\n        border: 1px solid ', ';\n        background: ', ';\n        pointer-events: none;\n\n        g {\n            fill: ', ';\n        }\n    }\n\n    &:hover {\n        border: ', ';\n    }\n'], ['\n    position: relative;\n    height: 40px;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    outline: none;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    background: ', ';\n    background: ', ';\n    color: ', ';\n\n    ', ';\n    ', ';\n\n    &:disabled {\n        border: 1px solid ', ';\n        background: ', ';\n        pointer-events: none;\n\n        g {\n            fill: ', ';\n        }\n    }\n\n    &:hover {\n        border: ', ';\n    }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    white-space: nowrap;\n    overflow: hidden;\n    margin-left: ', 'px;\n    text-align: left;\n    flex: 1;\n    border: 0;\n    background: inherit;\n    width: inherit;\n    height: auto;\n\n    ', ';\n    ', ';\n\n    ', ';\n\n    &::placeholder {\n        font-family: ', ';\n        font-weight: ', ';\n        font-size: ', ';\n        line-height: ', ';\n        letter-spacing: ', ';\n        color: ', ';\n    }\n\n    &:hover {\n        border: 0;\n    }\n\n    &:focus {\n        border: 0;\n        outline: none\n    }\n'], ['\n    white-space: nowrap;\n    overflow: hidden;\n    margin-left: ', 'px;\n    text-align: left;\n    flex: 1;\n    border: 0;\n    background: inherit;\n    width: inherit;\n    height: auto;\n\n    ', ';\n    ', ';\n\n    ', ';\n\n    &::placeholder {\n        font-family: ', ';\n        font-weight: ', ';\n        font-size: ', ';\n        line-height: ', ';\n        letter-spacing: ', ';\n        color: ', ';\n    }\n\n    &:hover {\n        border: 0;\n    }\n\n    &:focus {\n        border: 0;\n        outline: none\n    }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    width: 15px;\n    pointer-events: none;\n    margin: 0 ', 'px;\n'], ['\n    width: 15px;\n    pointer-events: none;\n    margin: 0 ', 'px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    top: 100%;\n    border: 0;\n    background: ', ';\n    box-shadow: 0 1px 1px 0 ', ';\n    width: 180px;\n\n    & > a {\n        padding: 15px;\n        border-top: 1px solid ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n'], ['\n    top: 100%;\n    border: 0;\n    background: ', ';\n    box-shadow: 0 1px 1px 0 ', ';\n    width: 180px;\n\n    & > a {\n        padding: 15px;\n        border-top: 1px solid ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    position: absolute;\n    right: -35px;\n    top: 50%;\n    transform: translateY(-50%);\n    outline: none;\n    background: none;\n    border: 0;\n    padding: ', 'px;\n    cursor: pointer;\n\n    svg {\n        width: 12px;\n        height: 10px;\n    }\n'], ['\n    position: absolute;\n    right: -35px;\n    top: 50%;\n    transform: translateY(-50%);\n    outline: none;\n    background: none;\n    border: 0;\n    padding: ', 'px;\n    cursor: pointer;\n\n    svg {\n        width: 12px;\n        height: 10px;\n    }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    z-index: 10;\n    display: ', ';\n    position: absolute;\n    ', '\n    width: 100%;\n    margin-bottom: 50px;\n    box-sizing: border-box;\n    background: ', ';\n    border: 0;\n    box-shadow: 0 0 8px ', '1A;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    max-height: ', 'px;\n    overflow: auto;\n    ', ';\n\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n'], ['\n    z-index: 10;\n    display: ', ';\n    position: absolute;\n    ', '\n    width: 100%;\n    margin-bottom: 50px;\n    box-sizing: border-box;\n    background: ', ';\n    border: 0;\n    box-shadow: 0 0 8px ', '1A;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    max-height: ', 'px;\n    overflow: auto;\n    ', ';\n\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    padding: 7px 0;\n    padding-left: ', 'px;\n    text-align: left;\n    cursor: pointer;\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    letter-spacing: ', ';\n    color: ', ';\n    background: ', ';\n\n    &:last-child {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n    }\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n        font-size: ', ';\n        line-height: ', ';\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    padding: 7px 0;\n    padding-left: ', 'px;\n    text-align: left;\n    cursor: pointer;\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    letter-spacing: ', ';\n    color: ', ';\n    background: ', ';\n\n    &:last-child {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n    }\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n        font-size: ', ';\n        line-height: ', ';\n    }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: ', ';\n'], ['\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../constants/colors');

var _radius = require('../../../constants/radius');

var _sizes = require('../../../constants/sizes');

var _opacity = require('../../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _text = require('../../../constants/text');

var _spinner = require('../../../atoms/icons/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _arrow = require('../../../atoms/icons/arrow');

var _arrow2 = _interopRequireDefault(_arrow);

var _inactive = require('../../../atoms/icons/close/inactive');

var _inactive2 = _interopRequireDefault(_inactive);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _error = require('../../../atoms/error');

var _error2 = _interopRequireDefault(_error);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _getColor = require('../../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _styles = require('../../../atoms/link/styles');

var _ = require('../../..');

var _errorLabel = require('../../../atoms/errorLabel');

var _errorLabel2 = _interopRequireDefault(_errorLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var isOpenedStyles = (0, _styledComponents.css)(_templateObject, function (_ref) {
	var error = _ref.error;
	return error ? _colors.Colors.Error : _colors.Colors.Primary;
});

var selectorStyles = (0, _styledComponents.css)(_templateObject2);

var DropDownWrapper = _styledComponents2.default.div(_templateObject3);

var ClearBtnWrapper = _styledComponents2.default.div(_templateObject4);

var menuStyles = (0, _styledComponents.css)(_templateObject5, _styles.Link1Styles);

var DropDownComponent = _styledComponents2.default.div(_templateObject6, _radius.Radius.small, function (_ref2) {
	var error = _ref2.error;
	return error ? _colors.Colors.Error : _colors.Colors.StrokeDark;
}, function (_ref3) {
	var error = _ref3.error;
	return error ? (0, _getColor2.default)(_colors.Colors.Error, _opacity2.default.VeryLight) : _colors.Colors.LightMode;
}, _colors.Colors.LightMode, function (_ref4) {
	var disabled = _ref4.disabled,
	    error = _ref4.error;

	if (disabled) return _colors.Colors.StrokeVeryDark;
	if (error) return _colors.Colors.Error;
	return _colors.Colors.PrimaryText;
}, function (_ref5) {
	var isOpenedState = _ref5.isOpenedState;
	return isOpenedState && isOpenedStyles;
}, function (_ref6) {
	var mode = _ref6.mode;
	return mode === 'menu' && menuStyles;
}, _colors.Colors.StrokeDark, _colors.Colors.LightMode, _colors.Colors.StrokeDark, function (_ref7) {
	var hasError = _ref7.hasError;
	return hasError ? '1px solid ' + _colors.Colors.Error : '1px solid ' + _colors.Colors.Primary;
});

var DropDownContent = _styledComponents2.default.input(_templateObject7, (0, _getSize2.default)(_sizes.Sizes.xs), function (_ref8) {
	var isBold = _ref8.isBold;
	return isBold && 'font-weight: ' + _text.TextSizes.WeightMedium;
}, function (_ref9) {
	var filterMode = _ref9.filterMode;
	return !filterMode && selectorStyles;
}, function (_ref10) {
	var textStyle = _ref10.textStyle;
	return textStyle === 'link' ? '' + _styles.Link1Styles : 'font-family: ' + _text.TextSizes.ParagraphFontFamily + ';\n\t\tfont-weight: ' + _text.TextSizes.WeightNormal + ';\n\t\tfont-size: ' + _text.TextSizes.P2FontSize + ';\n\t\tline-height: ' + _text.TextSizes.P2LineHeight + ';\n\t\tletter-spacing: ' + _text.TextSizes.ParagraphLetterSpacing + ';\n\t\tcolor: ' + function (_ref11) {
		var disabled = _ref11.disabled,
		    error = _ref11.error;

		if (disabled) return _colors.Colors.StrokeVeryDark;
		if (error) return _colors.Colors.Error;
		return _colors.Colors.PrimaryText;
	} + ';';
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref12) {
	var disabled = _ref12.disabled,
	    error = _ref12.error;

	if (disabled) return _colors.Colors.StrokeVeryDark;
	if (error) return (0, _getColor2.default)(_colors.Colors.Error, _opacity2.default.Light);
	return _colors.Colors.StrokeVeryDark;
});

var DropDownArrowWrapper = _styledComponents2.default.div(_templateObject8, (0, _getSize2.default)(_sizes.Sizes.xs));

var menuListStyles = (0, _styledComponents.css)(_templateObject9, _colors.Colors.LightMode, _colors.Colors.StrokeLight, _colors.Colors.StrokeLight, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.VeryLight));

var ClearButton = _styledComponents2.default.button(_templateObject10, (0, _getSize2.default)(_sizes.Sizes.xs));

var DropDownList = _styledComponents2.default.div(_templateObject11, function (_ref13) {
	var isOpenedState = _ref13.isOpenedState;
	return isOpenedState ? 'block' : 'none';
}, function (_ref14) {
	var direction = _ref14.direction;
	return direction === 'up' ? 'bottom: calc(100% - 50px);' : 'top: calc(100% + 5px);';
}, _colors.Colors.LightMode, _colors.Colors.PrimaryText, function (_ref15) {
	var height = _ref15.height;
	return height ? height : 200;
}, function (_ref16) {
	var mode = _ref16.mode;
	return mode === 'menu' && menuListStyles;
}, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Medium), _radius.Radius.large, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Dark));

var DropDownElement = _styledComponents2.default.a(_templateObject12, (0, _getSize2.default)(_sizes.Sizes.sm), _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref17) {
	var disabled = _ref17.disabled,
	    error = _ref17.error,
	    selected = _ref17.selected;

	if (disabled) return _colors.Colors.StrokeVeryDark;
	if (error) return _colors.Colors.Error;
	if (selected) return _colors.Colors.Secondary;
	return _colors.Colors.PrimaryText;
}, function (_ref18) {
	var selected = _ref18.selected;

	return selected ? (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.VeryLight) : '';
}, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.VeryLight), _colors.Colors.Secondary, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight);

var Backdrop = _styledComponents2.default.div(_templateObject13, function (_ref19) {
	var isOpenedState = _ref19.isOpenedState;
	return isOpenedState ? 'block' : 'none';
});

var DropDown = function (_React$Component) {
	_inherits(DropDown, _React$Component);

	function DropDown(props) {
		_classCallCheck(this, DropDown);

		var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props));

		_this.handleClickSelect = function () {
			_this.setState({
				isOpenedState: !_this.state.isOpenedState,
				selectedIndex: _this.state.selectedIndex || 0
			});

			var containerDOMNode = _reactDom2.default.findDOMNode(_this.contentRef.current);
			containerDOMNode.focus();
		};

		_this.handleOnBlur = function () {
			_this.setState({
				isOpenedState: false
			});

			if (_this.props.onBlur) _this.props.onBlur();
		};

		_this.handleOnChange = function (e, option) {
			e.stopPropagation();
			_this.props.changeEvent({
				value: option.value,
				code: option.code
			});
			_this.handleOnBlur();

			_this.setState({
				searchMode: false
			});
		};

		_this.handleFilter = function (e) {
			_this.props.changeEvent({
				value: '',
				code: ''
			});
			var value = e.target.value;
			var references = _this.props.references;

			if (_this.props.enableSearchCall) {
				_this.props.referencesEvent(value);
			} else {
				if (value) {
					references = references.filter(function (item) {
						return item.value.toLowerCase().search(value.toLowerCase()) !== -1;
					});
				}
			}

			_this.setState({
				searchMode: true,
				references: references,
				isOpenedState: true,
				selectedIndex: 0
			});
		};

		_this.handleKeyPress = function (e) {
			var references = _this.state.searchMode ? _this.state.references : _this.props.references;
			var hasReferences = references.length > 0;
			if (!hasReferences) return;

			if (e.key === 'Enter' || e.key === 'Tab') {
				if (_this.state.isOpenedState) {
					var selectedItem = references[_this.state.selectedIndex];
					_this.handleOnChange(e, selectedItem);
				} else {
					_this.setState({
						isOpenedState: true,
						selectedIndex: _this.state.selectedIndex || 0
					});
				}
			} else if (e.key === 'ArrowDown') {
				var newIndex = Math.min(_this.state.selectedIndex + 1 || 0, references.length - 1);
				_this.setState({ selectedIndex: newIndex });
				if (!_this.state.isOpenedState) {
					var _selectedItem = references[newIndex];
					_this.handleOnChange(e, _selectedItem);
				} else {
					_this.setScrollPosition(newIndex);
				}
			} else if (e.key === 'ArrowUp') {
				var _newIndex = Math.max(_this.state.selectedIndex - 1 || 0, 0);
				_this.setState({ selectedIndex: _newIndex });
				if (!_this.state.isOpenedState) {
					var _selectedItem2 = references[_newIndex];
					_this.handleOnChange(e, _selectedItem2);
				} else {
					_this.setScrollPosition(_newIndex);
				}
			}
		};

		_this.listRef = _react2.default.createRef();
		_this.contentRef = _react2.default.createRef();
		_this.dropdownRef = _react2.default.createRef();

		_this.state = {
			isOpenedState: false,
			openAbove: false,
			references: null,
			fetching: false,
			searchMode: false,
			filterMode: _this.props.filterMode != null ? _this.props.filterMode : true
		};

		_this.handleClickSelect = _this.handleClickSelect.bind(_this);
		_this.handleOnBlur = _this.handleOnBlur.bind(_this);
		_this.handleOnChange = _this.handleOnChange.bind(_this);
		_this.handleFilter = _this.handleFilter.bind(_this);
		_this.handleKeyPress = _this.handleKeyPress.bind(_this);
		return _this;
	}

	_createClass(DropDown, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this2 = this;

			if (!this.props.references && !this.state.fetching) {
				this.props.referencesEvent();
			} else if (!this.state.references && this.props.references) {
				this.setState({ references: this.props.references });
				if (this.props.value && this.props.references && this.props.references.length > 0) {
					var selectedOption = this.props.references.find(function (option) {
						return option.code === _this2.props.value.code;
					});
					if (selectedOption) {
						var selectedIndex = this.props.references.indexOf(selectedOption);
						this.setState({ selectedIndex: selectedIndex });
						this.setScrollPosition(selectedIndex);
					}
				}
				this.setState({ fetching: false });
			}
			// Check if dropdown should be opened above
			if (this.state.isOpenedState && !prevState.isOpenedState) {
				if (this.dropdownRef.current && this.listRef.current) {
					var dropdownRect = this.dropdownRef.current.getBoundingClientRect();
					var listHeight = this.listRef.current.offsetHeight;

					var spaceBelow = window.innerHeight - dropdownRect.bottom;

					if (spaceBelow < listHeight) {
						var spaceAbove = dropdownRect.top;

						// If there's more space above than below, set openAbove to true.
						if (spaceAbove > spaceBelow) {
							this.setState({ openAbove: true });
						} else {
							// Otherwise, keep it opening below.
							this.setState({ openAbove: false });
						}
					} else {
						// If there's enough space below, open it below.
						this.setState({ openAbove: false });
					}
				}
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this3 = this;

			if (!this.props.references || this.props.alwaysFetch) {
				this.props.referencesEvent();
				this.setState({ fetching: true });
			} else {
				this.setState({ references: this.props.references });
				if (this.props.value && this.props.references && this.props.references.length > 0) {
					var selectedOption = this.props.references.find(function (option) {
						return option.code === _this3.props.value.code;
					});
					if (selectedOption) {
						var selectedIndex = this.props.references.indexOf(selectedOption);
						this.setState({ selectedIndex: selectedIndex });
						this.setScrollPosition(selectedIndex);
					}
				}
				this.setState({ fetching: false });
			}
		}
	}, {
		key: 'setScrollPosition',
		value: function setScrollPosition(selectedIndex) {
			var containerDOMNode = _reactDom2.default.findDOMNode(this.listRef.current);
			var itemHeight = 35; // TextSizes.P2LineHeight = 21, padding = 7
			if (containerDOMNode) {
				containerDOMNode.scrollTop = itemHeight * selectedIndex;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var references = this.state.searchMode ? this.state.references : this.props.references;

			var value = !this.state.filterMode ? '' : null;
			var contentProps = {
				textStyle: this.props.mode === 'menu' ? 'link' : 'paragraph',
				inverse: this.props.inverse,
				isBold: this.props.mode === 'menu' && this.props.value && this.props.value.code !== 'any',
				filterMode: this.state.filterMode
			};

			if (this.props.value && references && references.length > 0) {
				var selectedOption = references.find(function (option) {
					return option.code === _this4.props.value.code;
				});
				if (selectedOption) {
					value = selectedOption.value;
				}
			}

			return _react2.default.createElement(
				_container2.default,
				{ top: this.props.top,
					bottom: this.props.bottom
				},
				this.props.label && _react2.default.createElement(_label2.default, { text: this.props.label,
					textAlign: _.Alignments.left,
					bottom: _sizes.Sizes.xxs,
					disabled: this.props.disabled,
					error: this.props.error
				}),
				!this.state.references ? _react2.default.createElement(_spinner2.default, { size: _sizes.Sizes.xl }) : _react2.default.createElement(
					DropDownWrapper,
					{ ref: this.dropdownRef },
					_react2.default.createElement(
						DropDownComponent,
						{
							key: 'DropDown',
							isOpenedState: this.state.isOpenedState,
							onClick: this.handleClickSelect,
							disabled: this.props.disabled,
							error: this.props.error,
							className: this.props.className,
							mode: this.props.mode || 'default',
							onBlur: this.props.blurEvent
						},
						this.props.mode !== 'menu' && (this.props.value || this.contentRef && this.contentRef.current && this.contentRef.current.value) && _react2.default.createElement(
							ClearBtnWrapper,
							{
								onClick: function onClick(e) {
									e.stopPropagation();
									_this4.contentRef.current.value = '';
									_this4.props.changeEvent({
										value: '',
										code: ''
									});
									_this4.setState({
										references: _this4.props.references
									});
								}
							},
							_react2.default.createElement(_.ClearIcon, { primary: 'darkgray',
								size: _sizes.Sizes.xs
							})
						),
						_react2.default.createElement(DropDownContent, _extends({
							value: value,
							placeholder: this.props.placeholder,
							onChange: this.handleFilter,
							onKeyDown: this.handleKeyPress,
							onBlur: this.handleOnBlur,
							error: this.props.error,
							ref: this.contentRef,
							readOnly: !this.state.filterMode
						}, contentProps)),
						(this.props.mode !== 'menu' || this.props.value && this.props.value.code === 'any') && _react2.default.createElement(
							DropDownArrowWrapper,
							{ key: 'DropDownArrow' },
							_react2.default.createElement(_arrow2.default, { direction: 'down',
								disabled: this.props.disabled
							})
						)
					),
					this.props.mode === 'menu' && this.props.value && this.props.value.code !== 'any' && _react2.default.createElement(
						ClearButton,
						{ onClick: this.props.clearEvent },
						_react2.default.createElement(_inactive2.default, null)
					),
					_react2.default.createElement(
						DropDownList,
						{
							isOpenedState: this.state.isOpenedState,
							error: this.props.error,
							mode: this.props.mode || 'default',
							height: this.props.listHeight,
							ref: this.listRef,
							direction: this.props.direction || this.state.openAbove ? 'up' : 'down'
						},
						references.filter(function (option) {
							return option.code !== 'any';
						}).map(function (option, i) {
							return _react2.default.createElement(
								DropDownElement,
								{ key: option.code,
									onMouseDown: function onMouseDown(e) {
										_this4.handleOnChange(e, option);
									},
									selected: _this4.state.selectedIndex === i
								},
								option.value
							);
						})
					),
					this.props.error && this.props.errorLabel && _react2.default.createElement(_error2.default, { text: this.props.errorLabel }),
					this.props.serverErrors && this.props.serverErrors.length !== 0 && !this.state.isOpenedState && this.props.serverErrors.map(function (err) {
						return _react2.default.createElement(_errorLabel2.default, { error: true,
							listItem: true,
							textAlign: 'left',
							text: err.message,
							disabled: _this4.props.disabled
						});
					}),
					this.props.serverWarnings && this.props.serverWarnings.length !== 0 && !this.state.isOpenedState && this.props.serverWarnings.map(function (war) {
						return _react2.default.createElement(_errorLabel2.default, { warning: true,
							listItem: true,
							textAlign: 'left',
							text: war.message,
							disabled: _this4.props.disabled
						});
					})
				),
				_react2.default.createElement(Backdrop, { isOpenedState: this.state.isOpenedState,
					onClick: this.handleOnBlur
				})
			);
		}
	}]);

	return DropDown;
}(_react2.default.Component);

exports.default = DropDown;